import React from 'react';
// @TODO move NewTopLevelPostCard out of Posts dir into a shared space
import NewTopLevelPostCard from '../Posts/NewTopLevelPostCard';

// @TODO on Post/onSubmit/onSubmitEdit success, just convert to edit mode and continue allowing user to write
// @TODO overhaul the NewTopLevelPostCard component for sake of this page
const Write = () => <NewTopLevelPostCard />;
export default Write;
